// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallToLogin_call-to-login__X243f {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: linear-gradient(81deg, var(--secondary-color) 0%, var(--accent-color) 99.48%);
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  margin-bottom: 8px;
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB .CallToLogin_user-image__HwEwH {
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.1);
  width: 36px;
  height: 36px;
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB .CallToLogin_user-image__HwEwH svg {
  width: 36px;
  height: 36px;
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB .CallToLogin_user-image__HwEwH svg path {
  stroke: var(--text-0);
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB .CallToLogin_username__w9N28 {
  color: var(--light-grey);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CallToLogin_call-to-login__X243f .CallToLogin_user-info__r\\+5lB .CallToLogin_user-content__jU6GR {
  gap: 0px;
}
.CallToLogin_call-to-login__X243f .CallToLogin_account-type__NVikQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.CallToLogin_call-to-login__X243f .CallToLogin_account-type__NVikQ .CallToLogin_label__8Ud4O {
  color: var(--light-grey);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CallToLogin_call-to-login__X243f .CallToLogin_account-type__NVikQ .CallToLogin_type__kgKZn {
  color: var(--text-0);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CallToLogin_call-to-login__X243f .CallToLogin_content__z9mCK {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.CallToLogin_call-to-login__X243f .CallToLogin_content__z9mCK .CallToLogin_title__rxrgk {
  color: var(--text-0);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CallToLogin_call-to-login__X243f .CallToLogin_content__z9mCK .CallToLogin_description__KVCvZ {
  color: var(--text-0);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.CallToLogin_call-to-login__X243f .CallToLogin_button__6F7t0 {
  align-self: stretch;
  background: rgba(255, 255, 255, 0.1);
  text-transform: uppercase;
}

.CallToLogin_login-modal__fM1JE {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/CallToLogin/CallToLogin.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,yFAAA;AACF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAII;EACE,qBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAFN;AAGM;EACE,WAAA;EACA,YAAA;AADR;AAGQ;EACE,qBAAA;AADV;AAMI;EACE,wBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAOI;EACE,QAAA;AALN;AASE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AAQI;EACE,wBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASI;EACE,oBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPN;AAWE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AATJ;AAUI;EACE,oBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARN;AAWI;EACE,oBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AATN;AAYE;EACE,mBAAA;EACA,oCAAA;EACA,yBAAA;AAVJ;;AAaA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAVF","sourcesContent":[".call-to-login {\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  border-radius: 8px;\n  background: linear-gradient(\n    81deg,\n    var(--secondary-color) 0%,\n    var(--accent-color) 99.48%\n  );\n\n  .user-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n    margin-bottom: 8px;\n    .user-image {\n      border-radius: 9999px;\n      background: rgba(255, 255, 255, 0.1);\n      width: 36px;\n      height: 36px;\n      svg {\n        width: 36px;\n        height: 36px;\n\n        path {\n          stroke: var(--text-0);\n        }\n      }\n    }\n\n    .username {\n      color: var(--light-grey);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    .user-content {\n      gap: 0px;\n    }\n  }\n\n  .account-type {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    .label {\n      color: var(--light-grey);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    .type {\n      color: var(--text-0);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    .title {\n      color: var(--text-0);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    .description {\n      color: var(--text-0);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n  .button {\n    align-self: stretch;\n    background: rgba(255, 255, 255, 0.1);\n    text-transform: uppercase;\n  }\n}\n.login-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"call-to-login": `CallToLogin_call-to-login__X243f`,
	"user-info": `CallToLogin_user-info__r+5lB`,
	"user-image": `CallToLogin_user-image__HwEwH`,
	"username": `CallToLogin_username__w9N28`,
	"user-content": `CallToLogin_user-content__jU6GR`,
	"account-type": `CallToLogin_account-type__NVikQ`,
	"label": `CallToLogin_label__8Ud4O`,
	"type": `CallToLogin_type__kgKZn`,
	"content": `CallToLogin_content__z9mCK`,
	"title": `CallToLogin_title__rxrgk`,
	"description": `CallToLogin_description__KVCvZ`,
	"button": `CallToLogin_button__6F7t0`,
	"login-modal": `CallToLogin_login-modal__fM1JE`
};
export default ___CSS_LOADER_EXPORT___;
